import { h, clear, highlightMatch } from '../utils/dom.js';

export function renderSearchPanel(overlayEl, boxEl, state, actions) {
	overlayEl.classList.toggle('blb-open', state.search.open);
	if (!state.search.open) return;

	// runSearch() re-renders this panel on every keystroke (once the search
	// resolves), which rebuilds the <input> as a brand-new DOM node — so the
	// browser drops focus unless we explicitly restore it (and the cursor
	// position) below, otherwise the user has to click back into the box
	// before typing the next character.
	const prevInput = boxEl.querySelector('#blb-search-input-el');
	const hadFocus = !!prevInput && document.activeElement === prevInput;
	const selStart = hadFocus ? prevInput.selectionStart : null;
	const selEnd = hadFocus ? prevInput.selectionEnd : null;

	clear(boxEl);

	const inputRow = h('div', { class: 'blb-search-input-row' }, [
		h('span', null, '🔍'),
		h('input', {
			class: 'blb-search-input',
			type: 'text',
			placeholder: state.i18n.searchPlaceholder,
			value: state.search.query,
			oninput: (e) => actions.runSearch(e.target.value),
			id: 'blb-search-input-el',
		}),
		h('button', { class: 'blb-close-btn', onClick: () => actions.closeSearch() }, '✕'),
	]);
	boxEl.appendChild(inputRow);

	const resultsEl = h('div', { class: 'blb-search-results' });

	const ref = state.search.reference;
	if (ref) {
		resultsEl.appendChild(
			h(
				'button',
				{
					class: 'blb-search-result',
					onClick: () => actions.goToReference(ref),
				},
				[
					h('div', { class: 'blb-search-result-ref' }, `↳ Go to ${ref.bookName} ${ref.chapter}${ref.verse ? ':' + ref.verse : ''}`),
					h('div', { class: 'blb-search-result-text' }, 'Jump directly to this reference'),
				]
			)
		);
	}

	if (!state.search.query.trim()) {
		resultsEl.appendChild(
			h('p', { class: 'blb-search-hint' }, 'Type a reference like "John 3:16", or a keyword to search chapters you’ve opened.')
		);
	} else if (state.search.results.length === 0 && !ref) {
		resultsEl.appendChild(h('p', { class: 'blb-search-hint' }, state.i18n.noResults));
	}

	state.search.results.forEach((r) => {
		resultsEl.appendChild(
			h(
				'button',
				{
					class: 'blb-search-result',
					onClick: () => actions.goToReference({ book: r.book, bookName: r.bookName, chapter: r.chapter, verse: r.verse }),
				},
				[
					h('div', { class: 'blb-search-result-ref' }, `${r.bookName} ${r.chapter}:${r.verse}`),
					h('div', { class: 'blb-search-result-text', html: highlightMatch(r.text, state.search.query) }),
				]
			)
		);
	});

	boxEl.appendChild(resultsEl);

	if (state.search.query.trim() && !ref) {
		const footer = h('div', { class: 'blb-search-input-row' });
		if (state.search.deepRunning) {
			const pct = state.search.deepProgress.total
				? Math.round((state.search.deepProgress.scanned / state.search.deepProgress.total) * 100)
				: 0;
			footer.appendChild(h('span', { class: 'blb-search-hint' }, `Searching full Bible… ${pct}%`));
			footer.appendChild(
				h('button', { class: 'blb-toolbar-btn', onClick: () => actions.stopDeepSearch() }, 'Stop')
			);
		} else {
			footer.appendChild(
				h(
					'button',
					{ class: 'blb-toolbar-btn', onClick: () => actions.startDeepSearch() },
					'🔎 Search entire Bible'
				)
			);
		}
		boxEl.appendChild(footer);
	}

	const input = boxEl.querySelector('#blb-search-input-el');
	if (input && (state.search.focusPending || hadFocus)) {
		input.focus();
		if (hadFocus && selStart !== null) {
			input.setSelectionRange(selStart, selEnd);
		}
		if (state.search.focusPending) {
			actions.clearSearchFocusFlag();
		}
	}
}
